import { Controller } from '@hotwired/stimulus'
import { searchPostalCode } from '../utils/postal_code'

export default class extends Controller {
  static targets = ['postalCode', 'prefecture', 'city', 'street', 'searchButton', 'errorMessage']

  declare postalCodeTarget: HTMLInputElement
  declare prefectureTarget: HTMLInputElement | HTMLSelectElement
  declare cityTarget: HTMLInputElement
  declare streetTarget: HTMLInputElement
  declare searchButtonTarget: HTMLButtonElement
  declare errorMessageTarget: HTMLElement

  async search() {
    const postalCode = this.postalCodeTarget.value
    this.errorMessageTarget.textContent = ''
    this.searchButtonTarget.disabled = true
    this.searchButtonTarget.textContent = '検索中...'

    try {
      const result = await searchPostalCode(postalCode)
      if (result) {
        this.prefectureTarget.value = result.prefecture
        this.cityTarget.value = result.city
        this.streetTarget.value = result.town
        this.prefectureTarget.dispatchEvent(new Event('change'))
      } else {
        this.errorMessageTarget.textContent = '該当する住所が見つかりません'
      }
    } catch {
      this.errorMessageTarget.textContent = '住所検索に失敗しました。手動で入力してください'
    } finally {
      this.searchButtonTarget.disabled = false
      this.searchButtonTarget.textContent = '住所検索'
    }
  }

  autoSearch() {
    const cleaned = this.postalCodeTarget.value.replace(/-/g, '')
    if (/^\d{7}$/.test(cleaned)) {
      this.search()
    }
  }
}
